import React from 'react';
import { Col } from 'reactstrap';
import ValidateButton from '../../Components-2025/QuestionBank/ValidateButton';
import SaveQuestion from '../../Components-2025/QuestionBank/SaveQuestion';
import ReportQuestion from '../../Components-2025/QuestionBank/ReportQuestion';

function QuestionBankFooter({
  validateQuestion,
  toggleReportSection,
  favItemId,
  onSaveItemChange,
  setChildRef,
  apiServiceProvider,
  savePayLoad,
  disabled = false, // default to false
}) {
  return (
    <Col sm={9} xs={12}>
      <div className='d-flex align-items-center mt-2 mb-1'>
        <ValidateButton onValidate={validateQuestion} disabled={disabled} />
        <SaveQuestion
          savePayLoad={savePayLoad}
          favItemId={favItemId}
          onSaveItemChange={onSaveItemChange}
          setChildRef={setChildRef}
          apiServiceProvider={apiServiceProvider}
        />
        <ReportQuestion onClick={toggleReportSection} />
      </div>
    </Col>
  );
}
export default QuestionBankFooter;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/QuestionBankFooter.jsx